// On-demand Crisp support chat. The widget script is NOT loaded with the app — it is
// injected the first time support is actually needed, so the chat bubble never appears
// uninvited. When the visitor closes the chat, the bubble hides again until the next
// explicit open.

const CRISP_WEBSITE_ID = '0d7a75b7-0bd1-453f-b33a-e2942223a333'

declare global {
  interface Window {
    $crisp: any[]
    CRISP_WEBSITE_ID: string
  }
}

let injected = false

/** Opens the Crisp chat, lazy-loading the widget on first use. Queued commands are
 *  replayed by the script once it finishes loading, so this is safe to call immediately.
 *  `message` pre-fills the visitor's compose box (they still press send), and `segment` tags
 *  the conversation so support can find every request of one kind. */
export const openSupportChat = (options?: { email?: string; message?: string; segment?: string }) => {
  window.$crisp = window.$crisp || []
  if (!injected) {
    injected = true
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID
    window.$crisp.push(['on', 'chat:closed', () => window.$crisp.push(['do', 'chat:hide'])])
    const script = document.createElement('script')
    script.src = 'https://client.crisp.chat/l.js'
    script.async = true
    document.head.appendChild(script)
  }
  if (options?.email) {
    window.$crisp.push(['set', 'user:email', [options.email]])
  }
  if (options?.segment) {
    window.$crisp.push(['set', 'session:segments', [[options.segment]]])
  }
  if (options?.message) {
    // Crisp ignores a message:text sent before its chatbox has rendered, which on a first open
    // is always the case (the script is still loading). So the text is set when the chatbox
    // opens, and once more as soon as Crisp reports itself ready.
    // Both hooks are one-shot, so a later chat opened from elsewhere (support, churn flow)
    // never inherits this text.
    const message = options.message
    const fill = () => window.$crisp.push(['set', 'message:text', [message]])
    window.$crisp.push([
      'on',
      'chat:opened',
      () => {
        fill()
        window.$crisp.push(['off', 'chat:opened'])
      },
    ])
    if (typeof (window.$crisp as any).is === 'function') {
      fill()
    } else {
      ;(window as any).CRISP_READY_TRIGGER = () => {
        ;(window as any).CRISP_READY_TRIGGER = undefined
        window.setTimeout(fill, 300)
      }
    }
  }
  window.$crisp.push(['do', 'chat:show'])
  window.$crisp.push(['do', 'chat:open'])
}
